import yup from './yup'
import moment from 'moment'

export const talkFormSchema = yup.object().shape({
  talk: yup.object().shape({
    title: yup.string().label('Title').trimmedRequired('Talk Title is required')
  }),
  venueId: yup.string().label('Venue').required(),
  startDate: yup.date().label('Start Date').required().typeError('Invalid date'),
  endDate: yup
    .date()
    .label('End date')
    .typeError('Invalid date')
    .test(
      'Date Check',
      { errType: 'Date', msg: 'End date must be after start date.' },
      function (value) {
        const startDate = moment(this.parent.startDate)
        const endDate = moment(value)
        return endDate.isSameOrAfter(startDate, 'date')
      }
    )
    .test(
      'Time Check',
      { errType: 'Time', msg: 'End Time must be after start Time.' },
      function (value) {
        const startDate = moment(this.parent.startDate)
        const endDate = moment(value)
        return endDate.isSameOrAfter(startDate)
      }
    )
    .required(),
  havePolls: yup.string().oneOf(['yes', 'no']),
  isAbstract: yup.boolean().label('Abstract Number'),
  posterNumber: yup.number().label('Poster number').required(),
  abstractNumber: yup.number().label('Abstract number').required()
})
